import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import globalConfig from './config/global'
import { downloadImage } from '@/utils/downloadImg'

Vue.prototype.$config = globalConfig
Vue.prototype.$axios = axios
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$downloadImg = downloadImage

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')